import React from "react";

export default function shop() {
  return (
    <div>
      <main className="main">
        <div className="page-header mt-30 mb-50">
          <div className="container">
            <div className="archive-header">
              <div className="row align-items-center">
                <div className="col-xl-3">
                  <h1 className="mb-15">Snack</h1>
                  <div className="breadcrumb">
                    <a rel="nofollow">
                      <i className="fi-rs-home mr-5" />
                      Home
                    </a>
                    <span /> Shop <span /> Snack
                  </div>
                </div>
                <div className="col-xl-9 text-end d-none d-xl-block"></div>
              </div>
            </div>
          </div>
        </div>
        <div className="container mb-30">
          <div className="row flex-row-reverse">
            <div className="col-lg-4-5">
              <div className="shop-product-fillter">
                <div className="totall-product">
                  <p>
                    We found <strong className="text-brand">29</strong> items
                    for you!
                  </p>
                </div>
                <div className="sort-by-product-area">
                  <div className="sort-by-cover mr-10">
                    <div className="sort-by-product-wrap">
                      <div className="sort-by">
                        <span>
                          <i className="fi-rs-apps" />
                          Show:
                        </span>
                      </div>
                      <div className="sort-by-dropdown-wrap">
                        <span>
                          {" "}
                          50 <i className="fi-rs-angle-small-down" />
                        </span>
                      </div>
                    </div>
                    <div className="sort-by-dropdown">
                      <ul>
                        <li>
                          <a className="active">50</a>
                        </li>
                        <li>
                          <a>100</a>
                        </li>
                        <li>
                          <a>150</a>
                        </li>
                        <li>
                          <a>200</a>
                        </li>
                        <li>
                          <a>All</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="sort-by-cover">
                    <div className="sort-by-product-wrap">
                      <div className="sort-by">
                        <span>
                          <i className="fi-rs-apps-sort" />
                          Sort by:
                        </span>
                      </div>
                      <div className="sort-by-dropdown-wrap">
                        <span>
                          Featured <i className="fi-rs-angle-small-down" />
                        </span>
                      </div>
                    </div>
                    <div className="sort-by-dropdown">
                      <ul>
                        <li>
                          <a className="active">Featured</a>
                        </li>
                        <li>
                          <a>Price: Low to High</a>
                        </li>
                        <li>
                          <a>Price: High to Low</a>
                        </li>
                        <li>
                          <a>Release Date</a>
                        </li>
                        <li>
                          <a>Avg. Rating</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row product-grid">
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-1-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-1-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                      <div className="product-badges product-badges-position product-badges-mrg">
                        <span className="hot">Hot</span>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Snack</a>
                      </div>
                      <h2>
                        <a>Seeds of Change Organic Quinoe</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>NestFood</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs28.85</span>
                          <span className="old-price">Rs32.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-2-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-2-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                      <div className="product-badges product-badges-position product-badges-mrg">
                        <span className="sale">Sale</span>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Hodo Foods</a>
                      </div>
                      <h2>
                        <a>All Natural Italian-Style Chicken Meatballs</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "80%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (3.5)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>Stouffer</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs52.85</span>
                          <span className="old-price">Rs55.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-3-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-3-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                      <div className="product-badges product-badges-position product-badges-mrg">
                        <span className="new">New</span>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Snack</a>
                      </div>
                      <h2>
                        <a>Angie’s Boomchickapop Sweet &amp; Salty</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "85%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>StarKist</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs48.85</span>
                          <span className="old-price">Rs52.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-4-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-4-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Vegetables</a>
                      </div>
                      <h2>
                        <a>Foster Farms Takeout Crispy Classic</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>NestFood</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs17.85</span>
                          <span className="old-price">Rs19.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-5-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-5-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                      <div className="product-badges product-badges-position product-badges-mrg">
                        <span className="best">-14%</span>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Pet Foods</a>
                      </div>
                      <h2>
                        <a>Blue Diamond Almonds Lightly</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>NestFood</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs23.85</span>
                          <span className="old-price">Rs25.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-6-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-6-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Hodo Foods</a>
                      </div>
                      <h2>
                        <a>Chobani Complete Vanilla Greek</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>NestFood</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs54.85</span>
                          <span className="old-price">Rs55.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-7-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-7-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Meats</a>
                      </div>
                      <h2>
                        <a>Canada Dry Ginger Ale – 2 L Bottle</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>NestFood</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs32.85</span>
                          <span className="old-price">Rs33.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-8-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-8-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                      <div className="product-badges product-badges-position product-badges-mrg">
                        <span className="sale">Sale</span>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Snack</a>
                      </div>
                      <h2>
                        <a>Encore Seafoods Stuffed Alaskan</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>NestFood</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs35.85</span>
                          <span className="old-price">Rs37.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-9-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-9-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                      <div className="product-badges product-badges-position product-badges-mrg">
                        <span className="hot">Hot</span>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Coffes</a>
                      </div>
                      <h2>
                        <a>Gorton’s Beer Battered Fish Fillets</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By
                          <a>Old El Paso</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs23.85</span>
                          <span className="old-price">Rs25.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6 d-none d-xl-block">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-10-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-10-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Cream</a>
                      </div>
                      <h2>
                        <a>Haagen-Dazs Caramel Cone Ice Cream</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "50%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (2.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>Tyson</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs22.85</span>
                          <span className="old-price">Rs24.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-1-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-1-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                      <div className="product-badges product-badges-position product-badges-mrg">
                        <span className="hot">Hot</span>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Snack</a>
                      </div>
                      <h2>
                        <a>Seeds of Change Organic Quinoe</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>NestFood</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs28.85</span>
                          <span className="old-price">Rs32.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-2-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-2-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                      <div className="product-badges product-badges-position product-badges-mrg">
                        <span className="sale">Sale</span>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Hodo Foods</a>
                      </div>
                      <h2>
                        <a>All Natural Italian-Style Chicken Meatballs</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "80%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (3.5)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>Stouffer</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs52.85</span>
                          <span className="old-price">Rs55.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-3-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-3-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                      <div className="product-badges product-badges-position product-badges-mrg">
                        <span className="new">New</span>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Snack</a>
                      </div>
                      <h2>
                        <a>Angie’s Boomchickapop Sweet &amp; Salty</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "85%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>StarKist</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs48.85</span>
                          <span className="old-price">Rs52.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-4-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-4-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Vegetables</a>
                      </div>
                      <h2>
                        <a>Foster Farms Takeout Crispy Classic</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>NestFood</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs17.85</span>
                          <span className="old-price">Rs19.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-5-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-5-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                      <div className="product-badges product-badges-position product-badges-mrg">
                        <span className="best">-14%</span>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Pet Foods</a>
                      </div>
                      <h2>
                        <a>Blue Diamond Almonds Lightly</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>NestFood</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs23.85</span>
                          <span className="old-price">Rs25.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-6-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-6-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Hodo Foods</a>
                      </div>
                      <h2>
                        <a>Chobani Complete Vanilla Greek</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>NestFood</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs54.85</span>
                          <span className="old-price">Rs55.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-7-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-7-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Meats</a>
                      </div>
                      <h2>
                        <a>Canada Dry Ginger Ale – 2 L Bottle</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>NestFood</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs32.85</span>
                          <span className="old-price">Rs33.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-8-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-8-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                      <div className="product-badges product-badges-position product-badges-mrg">
                        <span className="sale">Sale</span>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Snack</a>
                      </div>
                      <h2>
                        <a>Encore Seafoods Stuffed Alaskan</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>NestFood</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs35.85</span>
                          <span className="old-price">Rs37.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-9-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-9-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                      <div className="product-badges product-badges-position product-badges-mrg">
                        <span className="hot">Hot</span>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Coffes</a>
                      </div>
                      <h2>
                        <a>Gorton’s Beer Battered Fish Fillets</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By
                          <a>Old El Paso</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs23.85</span>
                          <span className="old-price">Rs25.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6 d-none d-xl-block">
                  <div className="product-cart-wrap">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-10-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-10-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Cream</a>
                      </div>
                      <h2>
                        <a>Haagen-Dazs Caramel Cone Ice Cream</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "50%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (2.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>Tyson</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs22.85</span>
                          <span className="old-price">Rs24.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
              </div>
              {/*product grid*/}
              <div className="pagination-area mt-20 mb-20">
                <nav aria-label="Page navigation example">
                  <ul className="pagination justify-content-start">
                    <li className="page-item">
                      <a className="page-link">
                        <i className="fi-rs-arrow-small-left" />
                      </a>
                    </li>
                    <li className="page-item">
                      <a className="page-link">1</a>
                    </li>
                    <li className="page-item active">
                      <a className="page-link">2</a>
                    </li>
                    <li className="page-item">
                      <a className="page-link">3</a>
                    </li>
                    <li className="page-item">
                      <a className="page-link dot">...</a>
                    </li>
                    <li className="page-item">
                      <a className="page-link">6</a>
                    </li>
                    <li className="page-item">
                      <a className="page-link">
                        <i className="fi-rs-arrow-small-right" />
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
              {/*End Deals*/}
            </div>
            <div className="col-lg-1-5 primary-sidebar sticky-sidebar">
              <div className="sidebar-widget widget-category-2 mb-30">
                <h5 className="section-title style-1 mb-30">Category</h5>
                <ul>
                  <li>
                    <a>
                      <img
                        src="assets/imgs/theme/icons/category-1.svg"
                        alt=""
                      />
                      Milks &amp; Dairies
                    </a>
                    <span className="count">30</span>
                  </li>
                  <li>
                    <a>
                      <img
                        src="assets/imgs/theme/icons/category-2.svg"
                        alt=""
                      />
                      Clothing
                    </a>
                    <span className="count">35</span>
                  </li>
                  <li>
                    <a>
                      <img
                        src="assets/imgs/theme/icons/category-3.svg"
                        alt=""
                      />
                      Pet Foods{" "}
                    </a>
                    <span className="count">42</span>
                  </li>
                  <li>
                    <a>
                      <img
                        src="assets/imgs/theme/icons/category-4.svg"
                        alt=""
                      />
                      Baking material
                    </a>
                    <span className="count">68</span>
                  </li>
                  <li>
                    <a>
                      <img
                        src="assets/imgs/theme/icons/category-5.svg"
                        alt=""
                      />
                      Fresh Fruit
                    </a>
                    <span className="count">87</span>
                  </li>
                </ul>
              </div>
              {/* Fillter By Price */}
              <div className="sidebar-widget price_range range mb-30">
                <h5 className="section-title style-1 mb-30">Fill by price</h5>
                <div className="price-filter">
                  <div className="price-filter-inner">
                    <div id="slider-range" className="mb-20" />
                    <div className="d-flex justify-content-between">
                      <div className="caption">
                        From:
                        <strong
                          id="slider-range-value1"
                          className="text-brand"
                        />
                      </div>
                      <div className="caption">
                        To:
                        <strong
                          id="slider-range-value2"
                          className="text-brand"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="list-group">
                  <div className="list-group-item mb-10 mt-10">
                    <label className="fw-900">Color</label>
                    <div className="custome-checkbox">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="checkbox"
                        id="exampleCheckbox1"
                        defaultValue=""
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheckbox1"
                      >
                        <span>Red (56)</span>
                      </label>
                      <br />
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="checkbox"
                        id="exampleCheckbox2"
                        defaultValue=""
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheckbox2"
                      >
                        <span>Green (78)</span>
                      </label>
                      <br />
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="checkbox"
                        id="exampleCheckbox3"
                        defaultValue=""
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheckbox3"
                      >
                        <span>Blue (54)</span>
                      </label>
                    </div>
                    <label className="fw-900 mt-15">Item Condition</label>
                    <div className="custome-checkbox">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="checkbox"
                        id="exampleCheckbox11"
                        defaultValue=""
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheckbox11"
                      >
                        <span>New (1506)</span>
                      </label>
                      <br />
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="checkbox"
                        id="exampleCheckbox21"
                        defaultValue=""
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheckbox21"
                      >
                        <span>Refurbished (27)</span>
                      </label>
                      <br />
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="checkbox"
                        id="exampleCheckbox31"
                        defaultValue=""
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheckbox31"
                      >
                        <span>Used (45)</span>
                      </label>
                    </div>
                  </div>
                </div>
                <a className="btn btn-sm btn-default">
                  <i className="fi-rs-filter mr-5" /> Fillter
                </a>
              </div>
              {/* Product sidebar Widget */}
              <div className="sidebar-widget product-sidebar mb-30 p-30 bg-grey border-radius-10">
                <h5 className="section-title style-1 mb-30">New products</h5>
                <div className="single-post clearfix">
                  <div className="image">
                    <img src="assets/imgs/shop/thumbnail-3.jpg" alt="#" />
                  </div>
                  <div className="content pt-10">
                    <h5>
                      <a>Chen Cardigan</a>
                    </h5>
                    <p className="price mb-0 mt-5">Rs99.50</p>
                    <div className="product-rate">
                      <div
                        className="product-rating"
                        style={{ width: "90%" }}
                      />
                    </div>
                  </div>
                </div>
                <div className="single-post clearfix">
                  <div className="image">
                    <img src="assets/imgs/shop/thumbnail-4.jpg" alt="#" />
                  </div>
                  <div className="content pt-10">
                    <h6>
                      <a>Chen Sweater</a>
                    </h6>
                    <p className="price mb-0 mt-5">Rs89.50</p>
                    <div className="product-rate">
                      <div
                        className="product-rating"
                        style={{ width: "80%" }}
                      />
                    </div>
                  </div>
                </div>
                <div className="single-post clearfix">
                  <div className="image">
                    <img src="assets/imgs/shop/thumbnail-5.jpg" alt="#" />
                  </div>
                  <div className="content pt-10">
                    <h6>
                      <a>Colorful Jacket</a>
                    </h6>
                    <p className="price mb-0 mt-5">Rs25</p>
                    <div className="product-rate">
                      <div
                        className="product-rating"
                        style={{ width: "60%" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="banner-img wow fadeIn mb-lg-0 animated d-lg-block d-none">
                <img src="assets/imgs/banner/banner-11.png" alt="" />
                <div className="banner-text">
                  <span>Oganic</span>
                  <h4>
                    Save 17% <br />
                    on <span className="text-brand">Oganic</span>
                    <br />
                    Juice
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
